import { type BookingUnit, type CatOffer, type CatOfferPrice } from "../types";

function getOfferPrices(offer: CatOffer | null | undefined): CatOfferPrice[] {
  const raw = offer?.offer_prices;
  return Array.isArray(raw) ? raw : [];
}

export function buildDefaultBookingUnitsQuantities(offer: CatOffer | null | undefined): Record<number, number> {
  const prices = getOfferPrices(offer);
  const quantities: Record<number, number> = {};
  for (const p of prices) {
    if (typeof p?.id === "number") quantities[p.id] = 0;
  }

  const first = prices[0];
  if (first?.id) {
    quantities[first.id] = 1;
  }
  return quantities;
}

export function buildBookingUnitsPayload(
  offer: CatOffer | null | undefined,
  bookingUnitsQuantities: Record<number, number> | null | undefined
): BookingUnit[] {
  const prices = getOfferPrices(offer);
  const quantities = bookingUnitsQuantities ?? {};
  return prices.map(p => ({
    id: p.id,
    quantity: Number.isFinite(Number(quantities[p.id])) ? Number(quantities[p.id]) : 0
  }));
}

export function buildEstimationBookingUnitsDetails(
  offer: CatOffer | null | undefined,
  bookingUnitsQuantities: Record<number, number> | null | undefined
): { booking_units: BookingUnit[] } {
  return {
    booking_units: buildBookingUnitsPayload(offer, bookingUnitsQuantities)
  };
}
